import React from 'react';

import {useInjectSaga} from 'utils/injectSaga';
import pagesSaga from 'sagas/foldersSaga';
import documentsSaga from 'sagas/documentsSaga';
import categorySaga from 'sagas/categorySaga';
import {getAdminTabSlug, getLabelArray, Menus, TRANSLATION_ADMIN_MENUS} from 'enums';
import {useDispatch} from 'react-redux';
import {fetchFolderSuccess} from 'actions/categoryActions';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Tabs from 'components/Tabs';
import history from 'utils/history';
import Chart from './Chart';

import Sitemap from './Sitemap';
import People from './People';
import Pages from './Pages';
import Roles from './Roles';
import Statics from './Statics';
import Files from './File';
import Icons from './Icons';
import Documents from './Documents';
import ModelUsage from './ModelUsage';
import TranslationStatus from './TranslationStatus';
import TranslationPrompt from './TranslationPrompt/index';
import TranslationSettings from './TranslationSettings';
import 'styles/dashboard.scss';
import 'styles/new-post.scss';
import Team from './Team';

const ADMIN_MENUS = getLabelArray(Menus);
const ADMIN_TABS = ADMIN_MENUS.filter(({label}) => !TRANSLATION_ADMIN_MENUS.includes(label));

const Admin = ({match}) => {
  useInjectSaga({key: 'pages', saga: pagesSaga});
  useInjectSaga({key: 'category', saga: categorySaga});
  useInjectSaga({key: 'documents', saga: documentsSaga});
  const dispatch = useDispatch();
  const {tabId, folderId} = match.params;

  const tabs = ADMIN_TABS;
  const selectedTab = ADMIN_MENUS.find((f) => getAdminTabSlug(f.label) === tabId);
  const menu = selectedTab || tabs[1];
  const isTranslationPage = TRANSLATION_ADMIN_MENUS.includes(menu.label);

  const renderSections = () => {
    if (!menu) return null;

    switch (menu.label) {
      case Menus.Sitemap:
        return <Sitemap />;
      case Menus.People:
        return <People />;
      case Menus.Pages:
        return <Pages />;
      case Menus.Role:
        return <Roles />;
      case Menus.Statistics:
        return <Statics />;
      case Menus.Team:
        return <Team />;
      case Menus.Images:
        return <Files folderId={folderId} />;
      case Menus.Icons:
        return <Icons folderId={folderId} />;
      case Menus.documents:
        return <Documents folderId={folderId} />;
      case Menus.ModelUsage:
        return <ModelUsage />;
      case Menus.TranslationStatus:
        return <TranslationStatus />;
      case Menus.TranslationPrompt:
        return <TranslationPrompt />;
      case Menus.TranslationSettings:
        return <TranslationSettings />;

      default:
        return (
          <div className="dashboard-list ">
            <div className="table-responsive statics-list"></div>
          </div>
        );
    }
  };

  return (
    <>
      <Header />
      <div className="wrapper">
        <Sidebar />
        <div className="content_wrapper">
          {!isTranslationPage && <Chart />}
          {!isTranslationPage && <div className="tab-box">
            <Tabs
              tabs={tabs}
              active={menu}
              onChange={(e) => {
                history.push(`/admin/${getAdminTabSlug(e.label)}`);
                dispatch(fetchFolderSuccess(null));
              }}
            />
          </div>}
          <div className="tab-content p-4 bg-white min-height">
            {renderSections()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
